import get from 'lodash/get';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps, ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';
import { getEntityContext, resolveDomainMetadata, matchesCurrentValidationContext,
  mapToValidationProps } from 'app/infrastructure/ui/renderer/resolvers';
import { ValidationProps } from 'ui/common/validation/types';
import { ValidationDomainMatch } from 'app/types-shared';

export const validationDescendants = (
  state: CaseState,
  uiEngineProps: ConnectedComponentProps
) => {

  const context = getEntityContext(state, uiEngineProps);
  const domainMetadata = resolveDomainMetadata(context, state, uiEngineProps);
  const children = uiEngineProps.componentDescriptor.children ? uiEngineProps.componentDescriptor.children
    .concat(
      uiEngineProps.detailsViewDescriptor ?
      uiEngineProps.detailsViewDescriptor.children :
      []
    ) : [];

  if (!context || !domainMetadata || !children) {
    return undefined;
  }

  const childValidationErrors: ValidationProps[] = [];

  const aggregatedErrorList = (child: ComponentDescriptor) => {
    const allValidations = get(domainMetadata, `[${child.id}].validations`, []) as ValidationDomainMatch[];
    const validations = allValidations.filter(v => matchesCurrentValidationContext(context, v));
    validations.length && childValidationErrors.push(mapToValidationProps(child.id, validations));

    child.children && child.children.filter(x => x).map(aggregatedErrorList);
  };

  const onlyUniqueMessages = (v, i, a) => i === a.findIndex( f => JSON.stringify(v.messages) === JSON.stringify(f.messages) );

  children.map(aggregatedErrorList);

  return { validationDescendants: childValidationErrors.filter( onlyUniqueMessages ) };
};
